import { render } from "./Resource.component.html?vue&type=template&id=e67dcac6&ts=true&external"
import script from "./Resource.component.ts?vue&type=script&lang=ts&external"
export * from "./Resource.component.ts?vue&type=script&lang=ts&external"

import "./Resource.component.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__